import { Fragment } from 'react';

import { MentionLink } from './MentionLink';
import { splitMentions } from './mention-token';

interface MentionTextProps {
  text: string;
}

/**
 * Body text with its mentions as links.
 *
 * Built from segments rather than markup: every plain run is rendered as a
 * React child, so it stays escaped, and there is no `dangerouslySetInnerHTML`
 * anywhere in the path a stranger's text travels (spec §11).
 */
export function MentionText({ text }: MentionTextProps) {
  const segments = splitMentions(text);

  return (
    <>
      {segments.map((segment, index) =>
        segment.kind === 'text' ? (
          <Fragment key={index}>{segment.text}</Fragment>
        ) : (
          <MentionLink
            key={index}
            label={segment.label}
            targetId={segment.targetId}
            targetKind={segment.targetKind}
          />
        ),
      )}
    </>
  );
}
